module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"fullscreen":"Vollbild","start/stop":"Start/Stop","ignore":"Ignorieren","continue":"Fortsetzen","startover":"Von Anfang","name":"Name","click behaviour":"Klickverhalten","caption":"Beschriftung","audio settings":"Audio-Einstellungen","autoplay":"Autoplay","mode":"Modus"}}')
  delete Component.options._Ctor
}
